import { Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { isNumber } from 'underscore';
import I18n from 'I18n';
import UIStepperInput from 'UIComponents/input/UIStepperInput';
import UISliderInput from 'UIComponents/input/UISliderInput';
import { NUMBER } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import DisplayTypes from 'ContentUtils/constants/CustomWidgetFieldDisplayTypes';
import { isNullOrUndefined } from 'ContentUtils/helpers/ObjectHelpers';
import NumberFormatTypes from 'ContentUtils/constants/NumberFormatTypes';
import { jsx as _jsx } from "react/jsx-runtime";
function isValidNumber(value) {
  return isNumber(value) && isFinite(value);
}
class NumberField extends Component {
  constructor(props) {
    super(props);
    this.numberFormatter = this.numberFormatter.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
  get seleniumKey() {
    const {
      fieldKey = []
    } = this.props;
    return fieldKey.join('.');
  }
  get placeholder() {
    const {
      min,
      placeholder
    } = this.props;
    if (placeholder) return placeholder;
    if (!isNullOrUndefined(this.props.default)) {
      return this.numberFormatter(this.props.default);
    }
    if (!isNullOrUndefined(min)) {
      return this.numberFormatter(min);
    }
    return this.numberFormatter(0);
  }
  numberFormatter(value) {
    const {
      prefix,
      suffix
    } = this.props;
    if (isNullOrUndefined(value)) return null;
    return `${prefix || ''}${I18n.formatNumber(value)}${suffix || ''}`;
  }
  onChange(e) {
    let value = e.target.value;
    const {
      min,
      max,
      onFieldChange,
      format = NumberFormatTypes.ANY,
      required
    } = this.props;
    if (isValidNumber(min) && (isValidNumber(value) ? value < min : required)) {
      value = min;
    }
    if (isValidNumber(max) && isValidNumber(value) && value > max) {
      value = max;
    }
    if (isNumber(value)) {
      if (format === NumberFormatTypes.INTEGER && !Number.isInteger(value)) {
        onFieldChange(Math.round(value));
      } else {
        onFieldChange(value);
      }
    } else {
      onFieldChange(null);
    }
  }
  renderText() {
    const {
      error = false,
      max,
      min,
      readOnly = false,
      step = 1,
      useOnDark,
      value = undefined
    } = this.props;
    return /*#__PURE__*/_jsx(UIStepperInput, {
      "data-selenium": this.seleniumKey,
      error: error,
      formatter: this.numberFormatter,
      max: max,
      min: min,
      onChange: this.onChange,
      placeholder: this.placeholder,
      readOnly: readOnly,
      stepSize: step,
      use: useOnDark ? 'on-dark' : 'default',
      value: value
    });
  }
  renderSlider() {
    const {
      error = false,
      max,
      min,
      readOnly = false,
      step = 1,
      useOnDark,
      value = undefined
    } = this.props;
    return /*#__PURE__*/_jsx(UISliderInput, {
      max: max,
      min: min,
      numberInputProps: {
        'data-selenium': this.seleniumKey,
        error,
        formatter: this.numberFormatter,
        use: useOnDark ? 'on-dark' : 'default',
        placeholder: this.placeholder
      },
      numberInputWidth: "45%",
      onChange: this.onChange,
      readOnly: readOnly,
      showLabels: true,
      step: step,
      value: value
    });
  }
  render() {
    const {
      display = 'text'
    } = this.props;
    return display === DisplayTypes[NUMBER].TEXT ? this.renderText() : this.renderSlider();
  }
}
export default NumberField;